type IframeResizeMessage = { type: "iframeResize"; height: number } | any;

type EmailModalOpenedMessage = {
  type: "roiCalculatorEmailModalOpened";
  clientX?: number;
  clientY?: number;
  scrollOffsetHeight?: number;
};

function isFinitePositiveNumber(v: unknown): v is number {
  return typeof v === "number" && Number.isFinite(v) && v > 0;
}

function isFiniteNumber(v: unknown): v is number {
  return typeof v === "number" && Number.isFinite(v);
}

function isFiniteNonNegativeNumber(v: unknown): v is number {
  return typeof v === "number" && Number.isFinite(v) && v >= 0;
}

export default function RoiCalculatorBlock() {
  const blocks = document.querySelectorAll<HTMLElement>(".js-roi-calculator");
  if (!blocks.length) return;

  window.addEventListener("message", (event: MessageEvent<IframeResizeMessage | EmailModalOpenedMessage>) => {
    const data = event.data;
    if (!data) return;

    if (data.type === "iframeResize") {
      if (!isFinitePositiveNumber(data.height)) return;

      blocks.forEach((block) => {
        const iframeId = block.getAttribute("data-iframe-id");
        if (!iframeId) return;

        const iframe = document.getElementById(iframeId) as HTMLIFrameElement | null;
        if (!iframe) return;

        const next = Math.max(200, Math.min(data.height, 5000));
        iframe.style.height = `${next}px`;
      });
      return;
    }

    if (data.type === "roiCalculatorEmailModalOpened") {
      if (!isFiniteNumber(data.clientX) || !isFiniteNumber(data.clientY)) return;

      const offsetPx = isFiniteNonNegativeNumber(data.scrollOffsetHeight) ? data.scrollOffsetHeight : 750;

      blocks.forEach((block) => {
        const iframeId = block.getAttribute("data-iframe-id");
        if (!iframeId) return;

        const iframe = document.getElementById(iframeId) as HTMLIFrameElement | null;
        if (!iframe || iframe.contentWindow !== event.source) return;

        const iframeRect = iframe.getBoundingClientRect();
        const buttonTopInViewport = iframeRect.top + data.clientY!;
        const scrollDelta = buttonTopInViewport - offsetPx;
        const scrollTarget = window.scrollY + scrollDelta;
        window.scrollTo({ top: Math.max(0, scrollTarget), behavior: "smooth" });
      });
    }
  });
}
